import React from "react";
import GlassPanel from "@/components/GlassPanel";
import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Reusable pagination bar for admin tables.
 * Props:
 *   - page, pageSize, total (numbers)
 *   - onPage(p), onPageSize(s)   controlled handlers
 *   - testIdPrefix               data-testid prefix, e.g. "admin-scores"
 */
export default function PaginationBar({
  page, pageSize, total, onPage, onPageSize, testIdPrefix,
}) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return (
    <GlassPanel className="mt-4 p-4 flex flex-wrap items-center gap-4" data-testid={`${testIdPrefix}-pagination`}>
      <div className="text-mute gps-mono text-xs tracking-[0.2em]">
        SHOWING <span className="text-white">{from}</span>
        {" – "}
        <span className="text-white">{to}</span>
        {" OF "}
        <span className="text-white" data-testid={`${testIdPrefix}-total`}>{total}</span>
      </div>
      <div className="flex-1" />
      <label className="gps-mono text-mute text-xs tracking-[0.2em]">
        PAGE SIZE
        <select
          className="gps-input ml-2 w-24"
          value={pageSize}
          onChange={(e) => { onPage(1); onPageSize(parseInt(e.target.value, 10)); }}
          data-testid={`${testIdPrefix}-page-size`}
        >
          {[10, 25, 50, 100].map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </label>
      <div className="flex gap-2 items-center">
        <button
          className="gps-btn ghost"
          disabled={page <= 1}
          onClick={() => onPage(Math.max(1, page - 1))}
          data-testid={`${testIdPrefix}-prev`}
        >
          <ChevronLeft size={12} /> PREV
        </button>
        <div className="gps-mono text-white text-xs tracking-[0.2em]" data-testid={`${testIdPrefix}-page`}>
          {page} / {totalPages}
        </div>
        <button
          className="gps-btn ghost"
          disabled={page >= totalPages}
          onClick={() => onPage(page + 1)}
          data-testid={`${testIdPrefix}-next`}
        >
          NEXT <ChevronRight size={12} />
        </button>
      </div>
    </GlassPanel>
  );
}
